import { service } from '@ember/service';
import MessagingBase from './messaging-base';

export default class MessagingProfile extends MessagingBase {
  @service intl;
  @service messagingLogging;

  // Overriding the default here as profile is a singleton endpoint
  // and doesn't follow the standard resource url patterns.
  pathForType() {
    return 'profile';
  }

  async updateAwayStatus(profileId, isAway) {
    if (isAway) {
      this.messagingLogging.trackEvent('emc.tracking_event_names.away_status_set');
    }
    return this.#updateProfile(profileId, {
      'is_away': isAway,
    });
  }

  async updateAwayMessage(profileId, awayMessage) {
    this.messagingLogging.trackEvent('emc.tracking_event_names.away_message_updated');
    return this.#updateProfile(profileId, {
      'away_message_text': awayMessage,
    });
  }

  async #updateProfile(profileId, attributes) {
    const url = `${this.host}/profile`;

    const response = await fetch(url, {
      method: 'PATCH',
      headers: this.headers,
      body: JSON.stringify({
        data: {
          type: 'profiles',
          id: profileId,
          attributes,
        },
      }),
    });

    if (!response.ok) {
      const error = new Error(this.intl.t('emc.general_error'));
      this.messagingLogging.error(error, {
        context: 'messaging-profile update',
        profileId,
        status: response.status,
      });
      throw error;
    }

    return response;
  }
}
